export default {
  // hóa đơn
  saleinvoice: 'SASaleInvoice',
  cancelInvoice: 'CancelInvoice',
  inventory: 'Inventory', // Phân hệ kho
  ininward: 'InventoryInInward', // Nhập kho
  inoutward: 'InventoryInOutward', // Xuất kho
  intransfer: 'INTransfer', // Chuyển kho
  inadjustment: 'InventoryInAjustment', // Điểu chỉnh tồn kho
  suincrement: 'InventoryItemSuincrement', // Ghi tăng CCDC
  sutransfer: 'InventoryItemSutransfer', // Điều chuyển CCDC
  sudecrement: 'InventoryItemSudecrement', // Ghi giảm CCDC
  statisticaldayoff: 'StatisticalDayOff', // Bảng tổng hợp ngày nghỉ/làm thêm/làm đêm
  otherincome: 'OtherIncome', // Thu nhập không thường xuyên
  paotheroutcome: 'PAOtherOutcome', // Khấu trừ không thường xuyên
  salary: 'Salary', // Bảng lương
  glpayrollexpensesalarylist: 'GlPayrollExpenseSalaryList', // Hạch toán chi phí lương
  PARetroSalary: 'PARetroSalary', // Bảng lương truy lĩnh
  // mua hàng
  pupayment: 'PUPayment',
  puvendorpayment: 'PUVendorPayment',
  puinvoice: 'PuInvoice',
  // bán hàng
  careceiptsale: 'CAReceiptSale',
  sainvoice: 'SAInvoice',
  careceiptcustomer: 'CAReceiptCustom',
  sareturn: 'SAReturn',

  // kho bạc
  buplanreceipt: 'BUPlanReceipt', // nhận dự toán
  budgetplan: 'BuPlanWithDraw', // Rút dự toán
  transfer: 'BUTransfer', // chuyển khoản kho bạc
  buvoucherlist: 'BUVoucherList', // bảng kê chứng từ thanh toán
  careceiptplanwithdrawlist: 'CAReceiptPlanWithdraw', // nhập quỹ tiền mặt
  buplanwdadjustment: 'BUPlanWDAdjustment', // điều chỉnh kinh phí
  buplanadjustment: 'BUPlanAdjustment', // điều chỉnh dự toán
  bucommitment: 'BUCommitmentRequest', // cam kết chi
  bucommitmentrequesttab: 'BUCommitmentRequest',
  bucommitmentadjustmenttab: 'BUCommitmentAdjustment',
  buopeningcommitmenttab: 'BUOpeningCommitment',
  bubudgetreserve: 'BUBudgetReserve', // dự toán giữ lại
  buplanimport: 'BUCommitmentAdjustment', // nhập dự toán
  buplancancel: 'BUPlanCancel', // hủy dự toán

  // tiền mặt
  careceipt: 'CAReceipt', // phiếu thu
  capayment: 'CAPayment', // phiếu chi

  // tiền gửi
  badeposit: 'BADeposit', // thu tiền gửi
  bawithdraw: 'BAWithDraw', // chi tiền gửi
  babanktransfer: 'BABankTransfer', // chuyển tiền nội bộ
  currency: 'Currency', // Loại tiền

  // danh mục
  systemaccounts: 'Account',
  employee: 'Employee',
  payrollitem: 'PayrollItem',
  employeetype: 'EmployeeType',
  budgetchapter: 'BudgetChapter',
  budgetgroupitem: 'BudgetGroupItem1',
  budgesourceproperty: 'BudgetGroupItem',
  budgetsource: 'BudgetSource',
  activity: 'Activity',
  branch: 'Branch',
  budgetFees: 'BudgetFees',
  budgetitem: 'BudgetItem',
  fixedasset: 'FixedAsset',
  budgetkinditem: 'BudgetKindItem',
  inventorycategory: 'InventoryCategory',
  inventory: 'InventoryItem1',
  currency: 'Currency',
  department: 'Department',
  fund: 'Fund',
  active: 'Active',
  bankinfocategory: 'TypeOfFundBank',
  bankinfo: 'BankInfo',
  statistic: 'Statistic',
  purchasepurpose: 'PurchasePurpose',
  accounttransfer: 'AccountTransfer',
  stock: 'Stock',
  autobusiness: 'AutoBusiness',
  customervendor: 'AccountingObject',
  accountingobjectcategory: 'AccountingObjectCategory',
  invoiceformnumber: 'InvoiceFormNumber',
  vouchertype: 'VoucherType',
  contract: 'Contract',
  project: 'Project',
  task: 'Task',
  topic: 'Topic',
  fundstructure: 'FundStructure',
  accountparallelrule: 'AccountParallelRule',
  defaultaccount: 'DefaultAccount',
  salaryscale: 'SalaryScale',
  budgetprovide: 'BudgetProvide',
  toollist: 'InventoryItem',
  tooltype: 'InventoryCategory1',
  option: 'PAOption',

  // hệ thống
  companyinfo: 'OrganizationInfo',
  usermanagement: 'UserManagement',
  datamanagement: 'DataManagement',
  AdvancedSercurity: 'AdvancedSercurity',
  sysrole: 'RoleManagement',
  dvcfile: 'DVCUser',
  dcsdfile: 'DVCUser', // Kho bạc điện tử

  // TSCĐ
  fatransfer: 'FATransfer', // Điều chuyển tài sản cố định
  faincrement: 'FAIncrement', // Nhận bằng hiện vật và ghi tăng TSCĐ
  fadecrement: 'FADecrement', // Ghi giảm TSCĐ
  fadepreciation: 'FADepreciation', // hao mòn
  fadevaluation: 'FADevaluation', // khấu hao
  fapurchaseincrement: 'FAPurchaseIncrement', // Mua và ghi tăng TSCĐ
  faadjustment: 'FaAdjustment', // Đánh giá lại TSCĐ
  farevenue: 'FARevenue', // Bán TSCĐ chưa thu tiền
  assetqlts: 'QltsVoucher', // Màn danh sách TSCĐ có kết nối MISA QLTS

  // Thuế
  tacircularvat: 'TACircularVATDeclaration',
};
